import EntitiesTable from "./EntitiesTable";

const CustomerEntities = () => (
  <div>
    <EntitiesTable />
  </div>
);

export default CustomerEntities;
